export default class Scroll {
    constructor() {
        this.$reveals = [];
        this.$smoothLinks = [];
        this.$scrollTriggers = [];
        this._onSmoothClick = this._onSmoothClick.bind(this);
        this._onScrollTriggerClick = this._onScrollTriggerClick.bind(this);
    }

    setScrollReveal() {
        this.$reveals = [...document.querySelectorAll('.js-scrollreveal')];
        if (this.$reveals.length === 0) return;

        const options = { rootMargin: '0px 0px -15%' };

        if (!('IntersectionObserver' in window)) {
            for (const $reveal of this.$reveals) {
                $reveal.classList.add('-reveal');
            }
            return;
        }

        for (const $reveal of this.$reveals) {
            const observer = new IntersectionObserver(this._callback, options);
            observer.observe($reveal);
        }
    }

    setSmoothScroll() {
        this.$smoothLinks = [...document.querySelectorAll('a.js-smoothscroll[href^="#"]')];
        if (this.$smoothLinks.length === 0) return;

        for (const $link of this.$smoothLinks) {
            $link.addEventListener('click', this._onSmoothClick, { passive: false });
        }
    }

    setScrollTrigger() {
        this.$scrollTriggers = [...document.querySelectorAll('.js-scroll-trigger')];
        if (this.$scrollTriggers.length === 0) return;

        for (const $trigger of this.$scrollTriggers) {
            $trigger.addEventListener('click', this._onScrollTriggerClick, { passive: false });
        }
    }

    _onSmoothClick(event) {
        const $link = event.currentTarget;
        const href = $link.getAttribute('href');
        if (!href || href === '#') return;

        const targetId = href.slice(1);
        const $target = document.getElementById(targetId);
        if (!$target) return;

        event.preventDefault();
        const offset = this._getScrollOffset($link);
        this._scrollToTarget($target, offset);
    }

    _onScrollTriggerClick(event) {
        const $trigger = event.currentTarget;
        const targetSelector = $trigger.dataset.scrollTarget;
        if (!targetSelector) return;

        const $target = document.querySelector(targetSelector);
        if (!$target) return;

        event.preventDefault();
        const offset = this._getScrollOffset($trigger);
        this._scrollToTarget($target, offset);
    }

    _scrollToTarget($target, offset) {
        const targetTop = window.pageYOffset + $target.getBoundingClientRect().top - offset;
        this._scrollToWithDuration(targetTop, 200);
    }

    _scrollToWithDuration(targetTop, duration) {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            window.scrollTo(0, targetTop);
            return;
        }

        const startTop = window.pageYOffset;
        const distance = targetTop - startTop;
        const startTime = performance.now();

        const easeInOutCubic = (t) => (t < 0.5
            ? 4 * t * t * t
            : 1 - Math.pow(-2 * t + 2, 3) / 2);

        const step = (now) => {
            const elapsed = now - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const eased = easeInOutCubic(progress);
            window.scrollTo(0, startTop + distance * eased);
            if (progress < 1) requestAnimationFrame(step);
        };

        requestAnimationFrame(step);
    }

    _getScrollOffset($el) {
        if ($el.hasAttribute('data-scroll-offset')) {
            return this._getResponsiveOffset();
        }

        const $pageNav = document.querySelector('.page-nav');
        if (!$pageNav) return 0;

        const rect = $pageNav.getBoundingClientRect();
        const top = Math.max(0, rect.top);
        return Math.round(top + rect.height);
    }

    _getResponsiveOffset() {
        return window.matchMedia('(max-width: 799px)').matches ? 91 : 166;
    }

    _callback(entries, observer) {
        for (const entry of entries) {
            if (!entry.isIntersecting) continue;

            // 表示クラスを追加
            entry.target.classList.add('-reveal');

            // 対象要素の監視を停止
            observer.unobserve(entry.target);
        }
    }
}
